import {UserIdentification, UserTrackingService} from './domain/user-tacking.service';

export class DummyUserTrackingService implements UserTrackingService {
    notifyUserHasChanged(_identification?: UserIdentification | undefined): void {
      //It does nothing
    }
    registerPushService(): void {
      //It does nothing
    }
}
